<p-tabView>
  <p-tabPanel header="Vitrine">
    <p>Selecione a planilha com os produtos a serem incluídos na vitrine</p>
    <div class="upload">
      <p-fileUpload
        accept=".xlsx"
        [auto]="true"
        [customUpload]="true"
        name="file"
        mode="basic"
        [maxFileSize]="1000000"
        chooseLabel="Selecionar"
        #upload
        (uploadHandler)="uploadFile($event, upload)"
      >
      </p-fileUpload>
      <table class="xlsx-sample">
        <thead>
          Planilha exemplo
          <tr>
            <th>InternalEAN</th>
            <th>Pontos troca</th>
            <th>Máximo trocas(/mês)</th>
            <th>Validade</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>150</td>
            <td>1</td>
            <td>10/05/2025</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>180</td>
            <td>1</td>
            <td>01/01/2030</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>160</td>
            <td>2</td>
            <td>01/08/2024</td>
          </tr>
          *a primeira linha sempre deve conter o cabeçalho
        </tbody>
      </table>
    </div>
    <br />
    <p-tabView *ngIf="variantsInStock || variantsNoStock || productsFailed">
      <p-tabPanel
        [header]="'Variantes habilitadas (' + variantsInStock.length + ')'"
        *ngIf="variantsInStock && variantsInStock.length"
      >
        <app-table
          [lazy]="false"
          [elements]="variantsInStock"
          [cols]="cols"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="productVariantName"
          [sortOrder]="-1"
          [showTitle]="false"
          [changeColumns]="true"
        />
      </p-tabPanel>
      <p-tabPanel
        [header]="
          'Variantes sem estoque mínimo (' + variantsNoStock.length + ')'
        "
        *ngIf="variantsNoStock && variantsNoStock.length"
      >
        <app-table
          [lazy]="false"
          [elements]="variantsNoStock"
          [cols]="cols"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="productVariantName"
          [showTitle]="false"
          [changeColumns]="true"
          [sortOrder]="-1"
        />
      </p-tabPanel>
      <p-tabPanel
        [header]="'Variantes não encontradas (' + productsFailed.length + ')'"
        *ngIf="productsFailed && productsFailed.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productsFailed"
          [cols]="colsFailed"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          [showTitle]="false"
          modelName="variantes"
          [changeColumns]="true"
          sortField="internalEAN"
          [sortOrder]="-1"
        />
      </p-tabPanel>
    </p-tabView>
  </p-tabPanel>
  <p-tabPanel header="Categorias">
    <p>Selecione a planilha com os produtos e categorias a serem vinculados</p>
    <div class="upload">
      <p-fileUpload
        accept=".xlsx"
        [auto]="true"
        [customUpload]="true"
        name="file"
        mode="basic"
        [maxFileSize]="1000000"
        chooseLabel="Selecionar"
        #uploadCategory
        (uploadHandler)="uploadCategoryFile($event, uploadCategory)"
      >
      </p-fileUpload>
      <table class="xlsx-sample">
        <thead>
          Planilha exemplo
          <tr>
            <th>InternalEAN</th>
            <th>Categoria</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>1.1</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>1.1.4</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>2</td>
          </tr>
          *a primeira linha sempre deve conter o cabeçalho
        </tbody>
      </table>
    </div>
    <br />
    <p-tabView
      *ngIf="productCategoryItens || productsNotFound || categoriesNotFound"
    >
      <p-tabPanel
        [header]="'Produtos alterados (' + productCategoryItens.length + ')'"
        *ngIf="productCategoryItens && productCategoryItens.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productCategoryItens"
          [cols]="colsCategory"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="internalEAN"
          [sortOrder]="-1"
          [showTitle]="false"
          [changeColumns]="true"
        />
      </p-tabPanel>
      <p-tabPanel
        [header]="'Variantes não encontradas (' + productsNotFound.length + ')'"
        *ngIf="productsNotFound && productsNotFound.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productsNotFound"
          [cols]="colsProductNotFound"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="internalEAN"
          [showTitle]="false"
          [changeColumns]="true"
          [sortOrder]="-1"
        />
      </p-tabPanel>
      <p-tabPanel
        [header]="
          'Categorias não encontradas (' + categoriesNotFound.length + ')'
        "
        *ngIf="categoriesNotFound && categoriesNotFound.length"
      >
        <app-table
          [lazy]="false"
          [elements]="categoriesNotFound"
          [cols]="colsCategoryNotFound"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          [showTitle]="false"
          modelName="variantes"
          [changeColumns]="true"
          sortField="categoryExternalId"
          [sortOrder]="-1"
        />
      </p-tabPanel>
    </p-tabView>
  </p-tabPanel>
  <p-tabPanel header="Preços">
    <p>Selecione a planilha com os produtos e o preço a ser atualizado</p>
    <div class="upload">
      <p-fileUpload
        accept=".xlsx"
        [auto]="true"
        [customUpload]="true"
        name="file"
        mode="basic"
        [maxFileSize]="1000000"
        chooseLabel="Selecionar"
        #uploadSalePrice
        (uploadHandler)="uploadSalePrices($event, uploadSalePrice)"
      >
      </p-fileUpload>
      <table class="xlsx-sample">
        <thead>
          Planilha exemplo
          <tr>
            <th>InternalEAN</th>
            <th>Preço de venda</th>
            <th>Preço de custo</th>
            <th>Validade</th>
            <th>Preço de alocação</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>10.5</td>
            <td>6.5</td>
            <td>Indeterminado</td>
            <td>5.0</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>13.7</td>
            <td>8.2</td>
            <td>10/04/2026</td>
            <td>7.0</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>2</td>
            <td>1.2</td>
            <td>10/06/2026</td>
            <td>4.5</td>
          </tr>
        </tbody>
        <div>*a primeira linha sempre deve conter o cabeçalho</div>
        <div>
          **Caso existam EANs duplicados na planilha, somente a última linha do
          item será atualizada.
        </div>
        <div>
          ***Não utilizar formatação monetária (R$), apenas o valor numérico
        </div>
      </table>
    </div>
    <br />
    <p-tabView *ngIf="productSalePriceItens || productSalePriceFail">
      <p-tabPanel
        [header]="'Produtos alterados (' + productSalePriceItens.length + ')'"
        *ngIf="productSalePriceItens && productSalePriceItens.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productSalePriceItens"
          [cols]="colsSalePrice"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="internalEAN"
          [sortOrder]="-1"
          [showTitle]="false"
          [changeColumns]="true"
        />
      </p-tabPanel>
      <p-tabPanel
        [header]="
          'Variantes não encontradas (' + productSalePriceFail.length + ')'
        "
        *ngIf="productSalePriceFail && productSalePriceFail.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productSalePriceFail"
          [cols]="colsSalePriceNotFound"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="internalEAN"
          [showTitle]="false"
          [changeColumns]="true"
          [sortOrder]="-1"
        />
      </p-tabPanel>
    </p-tabView>
  </p-tabPanel>
  <p-tabPanel header="Informações básicas">
    <p>
      Selecione a planilha com os produtos e as informações a serem atualizadas
    </p>
    <div class="upload">
      <p-fileUpload
        accept=".xlsx"
        [auto]="true"
        [customUpload]="true"
        name="file"
        mode="basic"
        [maxFileSize]="1000000"
        chooseLabel="Selecionar"
        #uploadBasicInfoButton
        (uploadHandler)="uploadBasicInfo($event, uploadBasicInfoButton)"
      >
      </p-fileUpload>
      <table class="xlsx-sample">
        <thead>
          Planilha exemplo
          <tr>
            <th>InternalEAN</th>
            <th>Nome do produto</th>
            <th>Marca</th>
            <th>DiamanteVermelho</th>
            <th>TipoEstoque</th>
            <th>Genero</th>
            <th>QtdItens</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>Máscara Facial...</td>
            <td>Glam</td>
            <td>red diamond</td>
            <td>classico</td>
            <td>U</td>
            <td>1</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>Gel de banho...</td>
            <td>Beautech</td>
            <td>red diamond bag</td>
            <td>premium</td>
            <td>F</td>
            <td>2</td>
          </tr>
          <tr>
            <td>XXXXXXXXXXXX</td>
            <td>Gel de banho...</td>
            <td>L'Occitane au Brésil</td>
            <td></td>
            <td></td>
            <td>M</td>
            <td></td>
          </tr>
        </tbody>
        <div>*a primeira linha sempre deve conter o cabeçalho</div>
        <div>
          **Caso existam EANs duplicados na planilha, somente a última linha do
          item será atualizada.
        </div>
        <div>
          ***O nome da marca deve estar idêntico ao cadastrado no sistema.
        </div>
        <div>
          ****DiamanteVermelho: red diamond, red diamond bag, red diamond box,
          red diamond combo, ou vazio (Todos). TipoEstoque: classico, premium ou
          vazio (Ambos). Genero: U, F ou M. QtdItens: número inteiro ≥ 1, ou
          vazio.
        </div>
      </table>
    </div>
    <br />
    <p-tabView
      *ngIf="productInfoItens || productInfoFail || productInfoNotFound"
    >
      <p-tabPanel
        [header]="'Produtos alterados (' + productInfoItens.length + ')'"
        *ngIf="productInfoItens && productInfoItens.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productInfoItens"
          [cols]="colsBasicInfo"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="internalEAN"
          [sortOrder]="-1"
          [showTitle]="false"
          [changeColumns]="true"
        />
      </p-tabPanel>
      <p-tabPanel
        [header]="
          'Variantes não encontradas (' + productInfoNotFound.length + ')'
        "
        *ngIf="productInfoNotFound && productInfoNotFound.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productInfoNotFound"
          [cols]="colsBasicInfoNotFound"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="internalEAN"
          [showTitle]="false"
          [changeColumns]="true"
          [sortOrder]="-1"
        />
      </p-tabPanel>
      <p-tabPanel
        [header]="'Marcas não encontradas (' + productInfoFail.length + ')'"
        *ngIf="productInfoFail && productInfoFail.length"
      >
        <app-table
          [lazy]="false"
          [elements]="productInfoFail"
          [cols]="colsBasicInfoFail"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          modelName="variantes"
          sortField="internalEAN"
          [showTitle]="false"
          [changeColumns]="true"
          [sortOrder]="-1"
        />
      </p-tabPanel>
    </p-tabView>
  </p-tabPanel>
</p-tabView>
